// extracted by mini-css-extract-plugin
module.exports = {"container":"CanvasTeam_container__VI_Kg","teamMain":"CanvasTeam_teamMain__orkqN","marquee":"CanvasTeam_marquee__Rzya6","header":"CanvasTeam_header__so643"};